import { OrderItem } from 'depoto-core/src/entities'
import { isEqual as areDeeplyEqual } from 'lodash-es'
import { baseMimeTypes } from './constants.util'
// import * as diff from 'deep-diff'
// import { isEqual } from 'lodash'

// interface SmartDiffResult<T> {
//   hasChanges: boolean
//   changedProperties: Partial<T>
//   fullDiff: any[]
// }

export function sortOrderItems(items): Array<OrderItem> {
  return [
    ...items.filter(item => item.type !== 'shipping' && item.type !== 'payment'),
    ...items.filter(item => item.type === 'payment'),
    ...items.filter(item => item.type === 'shipping'),
  ]
}
export function getObjectDiff(obj1: object, obj2: object) {
  if (!obj1 || !obj2) {
    return
  }
  return Object.keys(obj1).reduce((result, key) => {
    if (!obj2.hasOwnProperty(key)) {
      result.push(key)
    } else if (areDeeplyEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key)
      result.splice(resultKeyIndex, 1)
    }
    return result
  }, Object.keys(obj2))
}

export function detectUTF8(uint8Array) {
  try {
    // An attempt to decode as UTF-8
    new TextDecoder('UTF-8', { fatal: true }).decode(uint8Array)
    return 'UTF-8'
  } catch (e) {
    return 'non-UTF-8'
  }
}

export function unknownMimeType(fileMimeType?: string) {
  return !baseMimeTypes.some(type => fileMimeType?.includes(type))
}

export function getFulfilled<T>(responses: Array<PromiseFulfilledResult<T> | PromiseRejectedResult>) {
  return responses.filter(r => r.status == 'fulfilled').map(r => (r as PromiseFulfilledResult<T>).value)
}

export function getRejected<T>(responses: Array<PromiseFulfilledResult<T> | PromiseRejectedResult>) {
  return responses.filter(r => r.status == 'rejected').map(r => (r as PromiseRejectedResult).reason)
}

export function isFormInvalid() {
  // todo. find another, angular, way - querySelectorAll gets all inputs from pages, even when they should be destroyed.
  const inputs = [...document.querySelectorAll('.filter-form input[pattern]')]
  // if(inputs.length) {
  //   console.log(inputs.filter(x => !(x as HTMLInputElement)?.validity?.valid).map(x => x['dataset'].cy))
  // }
  return inputs.length && inputs.some(x => !(x as HTMLInputElement)?.validity?.valid)
}

export function historyBack(): void {
  window.history.back()
}

export function isObjectEmpty(obj: object): boolean {
  return obj === null || !Object.keys(obj)?.length
}

// function getChangedPropertiesDeep<T extends Record<string, any>>(original: T, modified: T): Partial<T> {
//   const changes: Partial<T> = {}
//   const allKeys = new Set([...Object.keys(original), ...Object.keys(modified)])
//
//   for (const key of allKeys) {
//     const originalValue = original[key]
//     const modifiedValue = modified[key]
//
//     if (!isEqual(originalValue, modifiedValue)) {
//       if (Array.isArray(originalValue) && Array.isArray(modifiedValue)) {
//         // Handle nested arrays
//         // @ts-ignore
//         changes[key] = modifiedValue
//         // changes[key as keyof T] = modifiedValue;
//       } else if (
//         typeof originalValue === 'object' &&
//         typeof modifiedValue === 'object' &&
//         originalValue !== null &&
//         modifiedValue !== null
//       ) {
//         // Handle nested objects
//         const nestedChanges = getChangedPropertiesDeep(originalValue, modifiedValue)
//         if (Object.keys(nestedChanges).length > 0) {
//           changes[key as keyof T] = nestedChanges as T[keyof T]
//         }
//       } else {
//         // Handle primitive values
//         changes[key as keyof T] = modifiedValue
//       }
//     }
//   }
//
//   return changes
// }

// export function getSmartObjectChanges<T extends Record<string, any>>(
//   original: T,
//   modified: T,
//   options: {
//     arrayItemIdKey?: string // Key to identify array items (default: 'id')
//     includeFullArraysFor?: string[] // Array properties to always include fully
//     preserveUnchangedItems?: boolean // Whether to include unchanged items with just ID (default: true)
//     sendFullChangedObjects?: boolean // Whether to send full objects for changed items (default: false)
//   } = {}
// ): SmartDiffResult<T> {
//   const {
//     arrayItemIdKey = 'id',
//     includeFullArraysFor = [],
//     preserveUnchangedItems = true,
//     sendFullChangedObjects = false,
//   } = options
//
//   const differences = diff(original, modified)
//
//   if (!differences || differences.length === 0) {
//     return {
//       hasChanges: false,
//       changedProperties: {} as Partial<T>,
//       fullDiff: [],
//     }
//   }
//
//   const changedProperties: any = {}
//   const processedArrays = new Set<string>()

// // First pass: handle non-array changes and identify array changes
// differences.forEach(change => {
//   if (change.path && change.path.length > 0) {
//     const rootProperty = change.path[0]
//
//     // Check if this is an array change
//     if (Array.isArray(original[rootProperty]) && !processedArrays.has(rootProperty)) {
//       processedArrays.add(rootProperty)
//
//       // Check if we should include the full array
//       if (includeFullArraysFor.includes(rootProperty)) {
//         changedProperties[rootProperty] = modified[rootProperty]
//       } else {
//         // Process array for server update
//         const arrayForUpdate = getArrayForServerUpdate(
//           original[rootProperty],
//           modified[rootProperty],
//           arrayItemIdKey,
//           preserveUnchangedItems,
//           sendFullChangedObjects
//         )
//
//         if (arrayForUpdate.hasChanges) {
//           changedProperties[rootProperty] = arrayForUpdate.items
//         }
//       }
//     } else if (!Array.isArray(original[rootProperty])) {
//         // Handle non-array properties
//         if (change.kind === 'E' || change.kind === 'N') {
//           changedProperties[rootProperty] = modified[rootProperty]
//         } else if (change.kind === 'D') {
//           changedProperties[rootProperty] = undefined
//         }
//       }
//     }
//   })
//
//   return {
//     hasChanges: true,
//     changedProperties,
//     fullDiff: differences,
//   }
// }
//
// function getArrayForServerUpdate<T extends Record<string, any>>(
//   originalArray: T[],
//   modifiedArray: T[],
//   idKey: string,
//   preserveUnchangedItems: boolean,
//   sendFullChangedObjects: boolean = false
// ): { hasChanges: boolean; items: T[] } {
//   const resultItems: T[] = []
//   let hasChanges = false
//
//   const originalMap = new Map(originalArray.map(item => [item[idKey], item]))
//   const modifiedMap = new Map(modifiedArray.map(item => [item[idKey], item]))
//
//   // Process all items in the modified array
//   modifiedArray.forEach(modifiedItem => {
//     const id = modifiedItem[idKey]
//     const originalItem = originalMap.get(id)
//
//     if (!originalItem) {
//       // New item - include full object
//       resultItems.push(modifiedItem)
//       hasChanges = true
//     } else if (!isEqual(originalItem, modifiedItem)) {
//       // Modified item - include full object or just changes based on option
//       if (sendFullChangedObjects) {
//         resultItems.push(modifiedItem)
//       } else {
//         const changedProperties = getChangedPropertiesDeep(originalItem, modifiedItem)
//         if (Object.keys(changedProperties).length > 0) {
//           resultItems.push({
//             [idKey]: id,
//             ...changedProperties,
//           } as T)
//         }
//       }
//       hasChanges = true
//     } else if (preserveUnchangedItems) {
//       // Unchanged item - include just ID to preserve it
//       resultItems.push({ [idKey]: id } as T)
//     }
//   })
//
//   // Check for deleted items
//   originalArray.forEach(originalItem => {
//     const id = originalItem[idKey]
//     if (!modifiedMap.has(id)) {
//       hasChanges = true // Item was deleted
//     }
//   })
//
//   return {
//     hasChanges,
//     items: resultItems,
//   }
// }

/**
 * Alternative approach: Get changes with detailed information about what changed
 */
// export function getDetailedArrayChanges<T extends Record<string, any>>(
//   original: T,
//   modified: T,
//   options: {
//     arrayItemIdKey?: string
//     includeChangeDetails?: boolean
//   } = {}
// ): {
//   hasChanges: boolean
//   changedProperties: Partial<T>
//   arrayChangeDetails?: Record<
//     string,
//     {
//       added: any[]
//       modified: any[]
//       removed: any[]
//       unchanged: any[]
//     }
//   >
// } {
//   const { arrayItemIdKey = 'id', includeChangeDetails = false } = options
//
//   const differences = diff(original, modified)
//
//   if (!differences || differences.length === 0) {
//     return {
//       hasChanges: false,
//       changedProperties: {} as Partial<T>,
//     }
//   }
//
//   const changedProperties: any = {}
//   const arrayChangeDetails: Record<string, any> = {}
//   const processedArrays = new Set<string>()
//
//   differences.forEach(change => {
//     if (change.path && change.path.length > 0) {
//       const rootProperty = change.path[0]
//
//       if (Array.isArray(original[rootProperty]) && !processedArrays.has(rootProperty)) {
//         processedArrays.add(rootProperty)
//
//         const arrayResult = getArrayForServerUpdate(
//           original[rootProperty],
//           modified[rootProperty],
//           arrayItemIdKey,
//           true
//         )
//
//         if (arrayResult.hasChanges) {
//           changedProperties[rootProperty] = arrayResult.items
//
//           if (includeChangeDetails) {
//             arrayChangeDetails[rootProperty] = getArrayChangeDetails(
//               original[rootProperty],
//               modified[rootProperty],
//               arrayItemIdKey
//             )
//           }
//         }
//       } else if (!Array.isArray(original[rootProperty])) {
//         if (change.kind === 'E' || change.kind === 'N') {
//           changedProperties[rootProperty] = modified[rootProperty]
//         } else if (change.kind === 'D') {
//           changedProperties[rootProperty] = undefined
//         }
//       }
//     }
//   })
//
//   const result: any = {
//     hasChanges: true,
//     changedProperties,
//   }
//
//   if (includeChangeDetails) {
//     result.arrayChangeDetails = arrayChangeDetails
//   }
//
//   return result
// }
//
// /**
//  * Get detailed information about array changes
//  */
// function getArrayChangeDetails<T extends Record<string, any>>(
//   originalArray: T[],
//   modifiedArray: T[],
//   idKey: string
// ): {
//   added: T[]
//   modified: T[]
//   removed: T[]
//   unchanged: T[]
// } {
//   const originalMap = new Map(originalArray.map(item => [item[idKey], item]))
//   const modifiedMap = new Map(modifiedArray.map(item => [item[idKey], item]))
//
//   const added: T[] = []
//   const modified: T[] = []
//   const removed: T[] = []
//   const unchanged: T[] = []
//
//   // Check modified array for new and modified items
//   modifiedArray.forEach(modifiedItem => {
//     const id = modifiedItem[idKey]
//     const originalItem = originalMap.get(id)
//
//     if (!originalItem) {
//       added.push(modifiedItem)
//     } else if (!isEqual(originalItem, modifiedItem)) {
//       modified.push(modifiedItem)
//     } else {
//       unchanged.push({ [idKey]: id } as T)
//     }
//   })
//
//   // Check original array for removed items
//   originalArray.forEach(originalItem => {
//     const id = originalItem[idKey]
//     if (!modifiedMap.has(id)) {
//       removed.push(originalItem)
//     }
//   })
//
//   return { added, modified, removed, unchanged }
// }
